export enum LogisticsStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
